module.exports = __webpack_public_path__ + "img/case61.6be4cb65.png";